var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"row row--fullwidth"},[_c('div',{staticClass:"col lg-6 sm-12"},[_c('LoginForm')],1),_vm._v(" "),_c('div',{staticClass:"col lg-6 sm-12 col--no-padding login-img"},[_c('UiImage',{attrs:{"path":_vm.img,"desktop":{ width: 1016 },"lazy":false}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }